import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CiiBadgeComponent } from '../../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-integration-ia',
  standalone: true,
  imports: [CiiBadgeComponent],
  templateUrl: './integration-ia.component.html',
  styleUrl: './integration-ia.component.css'
})
export class IntegrationIaComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Intégration IA & Solutions LLM (RAG, Agents) sur Mesure — Expert Agréé CII");
    this.metaService.updateTag({ name: 'description', content: "Agence experte en intégration IA pour entreprises. Solutions RAG, Agents IA et modèles LLM sécurisés (Azure, Mistral, Llama). Projets éligibles au Crédit Impôt Innovation." });
  }
}